// deactivate extras
// transfer | hotel code empty

import _ from 'lodash';
import * as storage from './storage';
import { checkCurrentDateIsBefore, checkTripStarts } from './checkTripStarts';

export function deactivateExtras() {
    if (storage.get('bookingData') !== null) {
        let getBookingData = storage.get('bookingData').data;

        // if transfer not already booked
        if (getBookingData.serviceInformation && getBookingData.serviceInformation.transfer === undefined) {
            if (getBookingData.searchParams.hotelCode.length === 0) {
                window.$content.extras['transfer'].active = false;
            }
        }

        // deactivate railAndFly & transfer in hotel only case
        if (getBookingData?.travelType === 'hotel') {
            if (window.$content.extras['railAndFly'] !== undefined) {
                window.$content.extras['railAndFly'].active = false;
            }

            if (window.$content.extras['transfer'] !== undefined) {
                window.$content.extras['transfer'].active = false;
            }
        }

        // delete transfer service : hotel serviceInformation not defined
        if (getBookingData.serviceInformation !== undefined && getBookingData.serviceInformation.hotel === undefined) {
            delete window.$content.extras['transfer'];
        }

        // Prüfen, ob Abreisedatum weniger als 1 Tag ist
        if (checkCurrentDateIsBefore(getBookingData.searchParams.retDate)) {
            window.$content.extras['excursion'].active = false;
        }

        // deactive seat reservation
        if (
            getBookingData.serviceInformation !== undefined &&
            (getBookingData.serviceInformation.flight === undefined || getBookingData?.allowSeatReservations === false)
        ) {
            window.$content.extras['seatReservation'].active = false;
        }

        // Prüfung auf Anreisedatum, dass dieses nicht heute, morgen oder in der Vergangenheit ist. Ansonsten bitte "Transfer", "Versicherung", "Rail & Fly" ausblenden
        if (storage.get('bookingData') != null && storage.get('bookingData').data != null) {
            if (checkTripStarts()) {
                let s = ['transfer', 'insurance', 'railAndFly'];
                _.forEach(s, function (v) {
                    if (window.$content.extras[v]?.active !== undefined) {
                        window.$content.extras[v].active = false;
                    }
                });
            }
        }
    }
}
